import Vue from 'vue';
import 'vuetify';
import Vuetify, { VBtn, VIcon, VSnackbar } from 'vuetify/lib';
import { VuetifyThemeVariant } from 'vuetify/types/services/theme';
import {
  linktivityPrimary,
  linktivitySecondary,
  linktivityAccent,
} from '@/styles/colors';
import en from 'vuetify/src/locale/en';
import ja from 'vuetify/src/locale/ja';
import zh from 'vuetify/src/locale/zh-Hans';
import zt from 'vuetify/src/locale/zh-Hant';
import ko from 'vuetify/src/locale/ko';
import VuetifyToast from 'vuetify-toast-snackbar';
import { AppTheme } from '@/store/modules/app';
import { getInitialTheme } from '@/utils/app';
import { getLocale } from '@/plugins/i18n';

Vue.use(Vuetify, {
  components: {
    VSnackbar,
    VBtn,
    VIcon,
  },
});

// theme
const linktivityTheme: Partial<VuetifyThemeVariant> = {
  primary: linktivityPrimary,
  secondary: linktivitySecondary,
  accent: linktivityAccent,
};

const initialIsDark = () => {
  return (getInitialTheme() as AppTheme) === AppTheme.Dark;
};

// vuetify based plugins
Vue.use(VuetifyToast, {
  x: 'center',
  y: 'top',
  icon: 'mdi-information',
  queueable: true,
  timeout: 300_000,
  multiLine: true,
});

const vuetify = new Vuetify({
  components: {
    VSnackbar,
    VBtn,
    VIcon,
  },
  icons: {
    iconfont: 'mdiSvg',
  },
  lang: {
    locales: { en, ja, zh, zt, ko },
    current: getLocale(),
  },
  theme: {
    dark: initialIsDark(),
    themes: {
      light: linktivityTheme,
      dark: linktivityTheme,
    },
  },
});

export default vuetify;
